import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User reordered libraries in custom sort',
  name: 'reordered_libraries',
  params: [
    {
      description: 'The id of the library that was moved',
      name: 'library_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
